import SetLang from "components/setLang";
import React, { Component } from "react";
import AppContainer from "../app-container/app-container";
import "./login-container.scss";
import hiteachLogo from "../../assets/images/hiteach_logo.png";
import careerNavigatorLogo from "../../assets/images/Career_Navigator_logo_Black.png";
class LoginContainer extends Component {
  state = {};
  render() {
    const logo =
      this.props.logo === ""
        ? hiteachLogo
        : window.location.hostname.split(".")[0] === "radware"
        ? careerNavigatorLogo
        : this.props.logo;
    return (
      <AppContainer>
        <div className="login-container">
          <div className="box login-box">
            <SetLang />

            {this.props.withLogo && (
              <div className="login-logo">
                <img src={logo} />
              </div>
            )}
            {this.props.children}
          </div>
        </div>
      </AppContainer>
    );
  }
}
export default LoginContainer;
